import React from "react";
import "./DashboardWithChatCard.css";

const DashboardWithChatCard = ({
  iconSrc,
  title,
  shortDescription,
  longDescription,
  children,
  handleCardOnClick,
}) => {
  return (
    <div
      className="dashboardcard"
      onClick={handleCardOnClick}
      style={{ cursor: "pointer" }}
    >
      <div className="card-icon-container">
        <img src={iconSrc} alt={title} className="card-icons" />
      </div>
      <div className="card-content">
        <h2>{title}</h2>
        <p>{shortDescription}</p>
        {longDescription && <p>{longDescription}</p>}
      </div>
      {children && <div style={{ width: "100%" }}>{children}</div>}
    </div>
  );
};

export default DashboardWithChatCard;
